export const en = {
  egypt: "EGYPT"
};

export const ar = {
  egypt: "مصر"
};
